"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeTheme = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const types_1 = require("../../types");
/**
 * Takes in a theme and returns a subset with only valid keys
 * Backfills with fallback values from `kyruusTheme`
 * @usage
 * ```
 *  const output = sanitizeTheme({
 *    color_button: 'gold',
 *    sw_color_button_text: '#FFFFFF'
 *  });
 *
 *  // output
 *
 *  const expectedTheme = {
 *    sw_font_face: 'Helvetica Neue, Helvetica, Arial, sans-serif',
 *    sw_font_size: '14px',
 *    ...other keys
 *
 *    // we didn't specify a `sw_color_button`
 *    // the fallback for `sw_color_button` is `color_button`
 *    // which we set to gold
 *    sw_color_button: 'gold',
 *
 *    // value was overridden directly
 *    sw_color_button_text: '#FFFFFF',
 *    sw_border_radius_button: '2px'
 *  };
 * ```
 * @param theme
 * @returns
 */
function sanitizeTheme(theme = {}) {
    const result = {};
    types_1.ThemeKeys.forEach((key) => {
        // @kyruus/ui-theme has fallbacks for all expected themeKeys
        result[key] = (0, ui_theme_1.fromTheme)(key)({ theme });
    });
    return result;
}
exports.sanitizeTheme = sanitizeTheme;
//# sourceMappingURL=sanitizeTheme.js.map